var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0053 11.8716H10.9948C8.64754 11.8716 6.74475 13.7744 6.74475 16.1216V25.8541C6.74475 28.2013 8.64754 30.1041 10.9948 30.1041H23.0053C25.3525 30.1041 27.2553 28.2013 27.2553 25.8541V16.1216C27.2553 13.7744 25.3525 11.8716 23.0053 11.8716Z",
    stroke: "#F98700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5574 11.8716V8.45317C21.5574 7.24447 21.0772 6.08527 20.2226 5.23059C19.3679 4.37591 18.2087 3.89575 17 3.89575C15.7913 3.89575 14.6321 4.37591 13.7774 5.23059C12.9227 6.08527 12.4426 7.24447 12.4426 8.45317V11.8716",
    stroke: "#F98700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.1128C18.1736 23.1128 19.125 22.1614 19.125 20.9878C19.125 19.8142 18.1736 18.8628 17 18.8628C15.8264 18.8628 14.875 19.8142 14.875 20.9878C14.875 22.1614 15.8264 23.1128 17 23.1128Z",
    fill: "#F98700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.1a1fdf6a8ccbdbf65b536c575545341a.svg";
export { ForwardRef as ReactComponent };